module.exports = __webpack_public_path__ + "static/media/coins.5891dd2b.svg";